module.exports = __webpack_public_path__ + "img/Icon-Pfeil-runter.d6218e5a.svg";